import axios from "../api";
export const appleLogin = async (params) => {
    const res = await axios.post("/auth/apple-login", params);
    return res.data;
};
//# sourceMappingURL=appleLogin.js.map